<div
  class="mobile-filters-trigger"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
>
  <lib-search-box
    [isMapVisible]="(isMapVisible$ | async) || false"
    (openMobileFilter)="openMobileFilters()"
    (inputFocus)="openSearchOverlay()"
  ></lib-search-box>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  (detach)="close()"
>
  <div class="mobile-filters" cdkTrapFocus cdkTrapFocusAutoCapture>
    <div class="mobile-filters__top-bar">
      <button class="mobile-filters__reset-all" (click)="resetAll()">
        {{ 'filters.common.deleteAll' | i18n }}
      </button>

      <h2 class="mobile-filters__title">
        {{ 'filters.common.filter' | i18n }}
      </h2>

      <button
        class="mobile-filters__close"
        (click)="closeAndIgnoreFilterChanges()"
      >
        <i
          class="mobile-filters__close-icon material-icon material-icon--outlined"
        >
          close
        </i>
      </button>
    </div>

    <div class="mobile-filters__main" cdkScrollable>
      <div class="mobile-filters__search-box">
        <lib-search-box
          [withChips]="false"
          (inputFocus)="openSearchOverlay()"
        ></lib-search-box>

        <div class="mobile-filters__chips" *ngIf="regions.length > 0">
          <ul class="mobile-filters__chip-list">
            <li
              class="mobile-filters__chip-item"
              *ngFor="let region of regions; trackBy: trackByRegion"
            >
              <lib-removable-chip (remove)="removeRegionFilter(region)">
                {{ region.name }}
              </lib-removable-chip>
            </li>
          </ul>

          <button
            class="mobile-filters__reset-chips"
            (click)="resetAllRegions()"
          >
            {{ 'filters.common.reset' | i18n }}
          </button>
        </div>
      </div>

      <div class="mobile-filters__filters">
        <div class="mobile-filters__row">
          <lib-contract-type-switch
            [currentOption]="filterState.contractType.filter"
            [options]="filterState.contractType.options"
            (update)="onContractTypeChange($event)"
          ></lib-contract-type-switch>
        </div>

        <div class="mobile-filters__row">
          <lib-category-filter
            (update)="onCategoryChange($event)"
          ></lib-category-filter>

          <div
            class="mobile-filters__subcategory"
            *ngIf="displaySubcategory"
            [class.mobile-filters__subcategory--visible]="isCategoryActive"
          >
            <lib-subcategory-filter
              [visibleCount]="3"
              [categoryFilter]="filterState.category.main.filter"
              (update)="onSubcategoryChange($event)"
            ></lib-subcategory-filter>
          </div>
        </div>

        <div class="mobile-filters__row">
          <lib-price-filter (update)="onPriceChange($event)"></lib-price-filter>
        </div>

        <div class="mobile-filters__row" *ngIf="displayRoomCount">
          <lib-room-count-filter
            (update)="onRoomCountChange($event)"
          ></lib-room-count-filter>
        </div>

        <div class="mobile-filters__row" *ngIf="displayLivingSpace">
          <lib-living-space-filter
            (update)="onLivingSpaceChange($event)"
          ></lib-living-space-filter>
        </div>

        <div class="mobile-filters__row" *ngIf="displayUsageSpace">
          <lib-usage-space-filter
            (update)="onUsageSpaceChange($event)"
          ></lib-usage-space-filter>
        </div>

        <div class="mobile-filters__row" *ngIf="displayPropertySpace">
          <lib-property-space-filter
            (update)="onPropertySpaceChange($event)"
          ></lib-property-space-filter>
        </div>

        <div class="mobile-filters__row">
          <app-search-subscription-button
            class="full-width"
            origin="mobile-filters"
          ></app-search-subscription-button>
        </div>
      </div>
    </div>

    <div class="mobile-filters__apply-button">
      <button class="filter-apply-button" (click)="showResults()">
        <ng-container
          *ngIf="
            (isAnyFilterActive$ | async) && (isLoading$ | async) === false;
            else defaultText
          "
        >
          {{
            'filters.common.showXResults'
              | i18n: { count: (resultCount$ | async) }
          }}
        </ng-container>
        <ng-template #defaultText>
          {{ 'filters.common.showResults' | i18n }}
        </ng-template>
      </button>
    </div>
  </div>
</ng-template>
